export function currencyFormat(num) {
  return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + " đ";
}

export function list_to_tree(list) {
  var map = {},
    node,
    roots = [],
    i;

  for (i = 0; i < list.length; i += 1) {
    map[list[i].id] = i; // initialize the map
    list[i].children = []; // initialize the children
  }

  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parentId !== "0") {
      // if you have dangling branches check that map[node.parentId] exists
      list[map[node.parentId]].children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
}

export function urlRegex(url) {
  const pattern = /^((http|https|ftp):\/\/)/;

  if (!pattern.test(url)) {
    url = "http://" + url;
  }
  return url;
}

// export function objectTotable(object) {
//   // ('Book ID', 'Book Name', 'Category' and 'Price')
//   let col = [];
//   for (let i = 0; i < object.length; i++) {
//     for (let key in object[i]) {
//       if (col.indexOf(key) === -1) {
//         col.push(key);
//       }
//     }
//   }
//   // Create table.
//   const table = document.createElement("table");
//   table.setAttribute("id", "table-transaction");
//   // Create table header row using the extracted headers above.
//   let tr = table.insertRow(-1); // table row.

//   for (let i = 0; i < col.length; i++) {
//     debugger
//     let th = document.createElement("th"); // table header.
//     th.innerHTML = col[i];
//     tr.appendChild(th);
//   }

//   // add json data to the table as rows.
//   for (let i = 0; i < object.length; i++) {
//     tr = table.insertRow(-1);

//     for (let j = 0; j < col.length; j++) {
//       let tabCell = tr.insertCell(-1);
//       tabCell.innerHTML = object[i][col[j]];
//     }
//   }
//   return table;
// }


export function objectToTable(obj) {
  // Create the table element
  var table = document.createElement("table");
  table.setAttribute("id", "table-transaction");

  // Iterate through the object properties
  for (var prop in obj) {
    // Create a new row
    var row = table.insertRow();
    // Add the property name to the first cell
    var cell1 = row.insertCell();
    cell1.innerHTML = prop;
    // Add the property value to the second cell
    var cell2 = row.insertCell();
    cell2.innerHTML = obj[prop];
  }

  return table;
}